/**
 * Coda di lettura vocale: sintetizza e riproduce le frasi **in ordine**, una
 * alla volta (worker singolo → niente sovrapposizioni). `stop()` interrompe
 * subito (svuota coda + ferma l'audio corrente).
 */

import { sintetizzaVoce } from "@/lib/agente-chat";

export class TtsPlayer {
  private coda: string[] = [];
  private inCorso = false;
  private annullato = false;
  private audio: HTMLAudioElement | null = null;

  constructor(
    private readonly onState: (parlando: boolean) => void,
    private readonly basePath: string = "/api/v1/m3/agente/chat",
  ) {}

  /** Accoda una frase da leggere; avvia il worker se fermo. */
  parla(testo: string): void {
    if (!testo.trim()) return;
    this.annullato = false;
    this.coda.push(testo);
    if (!this.inCorso) void this.processa();
  }

  /** Ferma tutto: coda svuotata, audio corrente interrotto. */
  stop(): void {
    this.annullato = true;
    this.coda = [];
    if (this.audio) {
      this.audio.pause();
      this.audio = null;
    }
    this.inCorso = false;
    this.onState(false);
  }

  private async processa(): Promise<void> {
    this.inCorso = true;
    this.onState(true);
    while (this.coda.length && !this.annullato) {
      const testo = this.coda.shift() as string;
      try {
        const blob = await sintetizzaVoce(testo, this.basePath);
        if (this.annullato) break;
        await this.riproduci(blob);
      } catch {
        // segmento fallito: salta, non bloccare la coda
      }
    }
    this.inCorso = false;
    this.onState(false);
  }

  private riproduci(blob: Blob): Promise<void> {
    return new Promise((resolve) => {
      const url = URL.createObjectURL(blob);
      const audio = new Audio(url);
      this.audio = audio;
      const fine = () => {
        URL.revokeObjectURL(url);
        if (this.audio === audio) this.audio = null;
        resolve();
      };
      audio.onended = fine;
      audio.onerror = fine;
      audio.play().catch(() => fine()); // autoplay bloccato → salta senza rompere
    });
  }
}
